var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "waba-activity-card", class: { expanded: _vm.isExpanded } },
    [
      _c(
        "div",
        { staticClass: "card-header", on: { click: _vm.toggleExpand } },
        [
          _c("div", { staticClass: "left-section" }, [
            _c(
              "div",
              { staticClass: "activity-icon", class: _vm.getActivityClass() },
              [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v(_vm._s(_vm.getActivityIcon())),
                ]),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "activity-info" }, [
              _c("div", { staticClass: "activity-title" }, [
                _vm._v(_vm._s(_vm.getActivityTitle())),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "activity-subtitle" }, [
                _vm._v(_vm._s(_vm.getActivitySubtitle())),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "right-section" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "tippy",
                    rawName: "v-tippy",
                    value: {
                      content: _vm
                        .$moment(_vm.activity.createdAt)
                        .format("DD/MM/YYYY HH:mm:ss"),
                    },
                    expression:
                      "{ content: $moment(activity.createdAt).format('DD/MM/YYYY HH:mm:ss') }",
                  },
                ],
                staticClass: "activity-time",
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$moment(_vm.activity.createdAt).fromNow()) +
                    "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "expand-icon" }, [
              _c("span", { staticClass: "material-icons" }, [
                _vm._v(_vm._s(_vm.isExpanded ? "expand_less" : "expand_more")),
              ]),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.isExpanded
        ? _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "details-grid" }, [
              _vm.$_.get(_vm.activity, "payload.event")
                ? _c("div", { staticClass: "detail-item" }, [
                    _c("span", { staticClass: "detail-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("whatsapp_business_api.activityEvent"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "detail-value event-badge",
                        class: _vm.getEventBadgeClass(),
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$_.get(_vm.activity, "payload.event")) +
                            "\n                "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$_.get(_vm.activity, "payload.originalEvent")
                ? _c("div", { staticClass: "detail-item" }, [
                    _c("span", { staticClass: "detail-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("whatsapp_business_api.activityOriginalEvent")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "detail-value event-badge",
                        class: _vm.getOriginalEventBadgeClass(),
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$_.get(_vm.activity, "payload.originalEvent")
                            ) +
                            "\n                "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.getViolationType()
                ? _c("div", { staticClass: "detail-item" }, [
                    _c("span", { staticClass: "detail-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("whatsapp_business_api.activityViolationType")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "detail-value violation-badge" },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.getViolationType()) +
                            "\n                "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$_.get(_vm.activity, "payload.channelId")
                ? _c("div", { staticClass: "detail-item" }, [
                    _c("span", { staticClass: "detail-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("whatsapp_business_api.activityChannelId")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "detail-value mono" }, [
                      _vm._v(
                        _vm._s(_vm.$_.get(_vm.activity, "payload.channelId"))
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$_.get(_vm.activity, "payload.message_template_name")
                ? _c("div", { staticClass: "detail-item" }, [
                    _c("span", { staticClass: "detail-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("whatsapp_business_api.activityTemplateName")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "detail-value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$_.get(
                            _vm.activity,
                            "payload.message_template_name"
                          )
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$_.get(_vm.activity, "payload.message_template_id")
                ? _c("div", { staticClass: "detail-item" }, [
                    _c("span", { staticClass: "detail-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("whatsapp_business_api.activityTemplateId")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "detail-value mono" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$_.get(
                            _vm.activity,
                            "payload.message_template_id"
                          )
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$_.get(_vm.activity, "payload.message_template_language")
                ? _c("div", { staticClass: "detail-item" }, [
                    _c("span", { staticClass: "detail-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("whatsapp_business_api.activityLanguage"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "detail-value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$_.get(
                            _vm.activity,
                            "payload.message_template_language"
                          )
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$_.get(_vm.activity, "payload.message_template_category")
                ? _c("div", { staticClass: "detail-item" }, [
                    _c("span", { staticClass: "detail-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("whatsapp_business_api.activityCategory"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "detail-value category-badge" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$_.get(
                            _vm.activity,
                            "payload.message_template_category"
                          )
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$_.get(_vm.activity, "payload.reason") &&
              _vm.$_.get(_vm.activity, "payload.reason") !== "NONE"
                ? _c("div", { staticClass: "detail-item" }, [
                    _c("span", { staticClass: "detail-label" }, [
                      _vm._v(
                        _vm._s(_vm.$t("whatsapp_business_api.activityReason"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "detail-value reason-badge" }, [
                      _vm._v(
                        _vm._s(_vm.$_.get(_vm.activity, "payload.reason"))
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$_.get(_vm.activity, "payload.previous_category")
                ? _c("div", { staticClass: "detail-item" }, [
                    _c("span", { staticClass: "detail-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "whatsapp_business_api.activityPreviousCategory"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "detail-value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$_.get(_vm.activity, "payload.previous_category")
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$_.get(_vm.activity, "payload.new_category")
                ? _c("div", { staticClass: "detail-item" }, [
                    _c("span", { staticClass: "detail-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("whatsapp_business_api.activityNewCategory")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "detail-value" }, [
                      _vm._v(
                        _vm._s(_vm.$_.get(_vm.activity, "payload.new_category"))
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$_.get(_vm.activity, "payload.correct_category")
                ? _c("div", { staticClass: "detail-item" }, [
                    _c("span", { staticClass: "detail-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "whatsapp_business_api.activityCorrectCategory"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "detail-value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$_.get(_vm.activity, "payload.correct_category")
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$_.get(_vm.activity, "payload.previous_quality_score")
                ? _c("div", { staticClass: "detail-item" }, [
                    _c("span", { staticClass: "detail-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "whatsapp_business_api.activityPreviousQuality"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "detail-value quality-badge",
                        class: _vm.getQualityClass(
                          _vm.$_.get(
                            _vm.activity,
                            "payload.previous_quality_score"
                          )
                        ),
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$_.get(
                                _vm.activity,
                                "payload.previous_quality_score"
                              )
                            ) +
                            "\n                "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.$_.get(_vm.activity, "payload.new_quality_score")
                ? _c("div", { staticClass: "detail-item" }, [
                    _c("span", { staticClass: "detail-label" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("whatsapp_business_api.activityNewQuality")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "detail-value quality-badge",
                        class: _vm.getQualityClass(
                          _vm.$_.get(_vm.activity, "payload.new_quality_score")
                        ),
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.$_.get(
                                _vm.activity,
                                "payload.new_quality_score"
                              )
                            ) +
                            "\n                "
                        ),
                      ]
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.violationDescription
              ? _c("div", { staticClass: "violation-description" }, [
                  _c("div", { staticClass: "violation-header" }, [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("gavel"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "whatsapp_business_api.activityViolationPolicyDetails"
                          )
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "violation-content" }, [
                    _c("div", { staticClass: "violation-title" }, [
                      _vm._v(_vm._s(_vm.getViolationType())),
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "violation-policy" }, [
                      _vm._v(_vm._s(_vm.violationDescription.policy)),
                    ]),
                    _vm._v(" "),
                    _vm.violationDescription.allowed &&
                    _vm.violationDescription.allowed.length > 0
                      ? _c("div", { staticClass: "violation-examples" }, [
                          _c("div", { staticClass: "examples-title" }, [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v("check_circle"),
                            ]),
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t(
                                    "whatsapp_business_api.activityAllowedExamples"
                                  )
                                ) +
                                "\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "ul",
                            _vm._l(
                              _vm.violationDescription.allowed,
                              function (example, idx) {
                                return _c("li", { key: "allowed-" + idx }, [
                                  _vm._v(_vm._s(example)),
                                ])
                              }
                            ),
                            0
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.violationDescription.notAllowed &&
                    _vm.violationDescription.notAllowed.length > 0
                      ? _c(
                          "div",
                          { staticClass: "violation-examples not-allowed" },
                          [
                            _c("div", { staticClass: "examples-title" }, [
                              _c("span", { staticClass: "material-icons" }, [
                                _vm._v("cancel"),
                              ]),
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$t(
                                      "whatsapp_business_api.activityNotAllowedExamples"
                                    )
                                  ) +
                                  "\n                    "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "ul",
                              _vm._l(
                                _vm.violationDescription.notAllowed,
                                function (example, idx) {
                                  return _c(
                                    "li",
                                    { key: "notallowed-" + idx },
                                    [_vm._v(_vm._s(example))]
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "json-preview" }, [
              _c("div", { staticClass: "json-header" }, [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v("data_object"),
                ]),
                _vm._v(" "),
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.$t("whatsapp_business_api.activityRawPayload"))
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "tippy",
                        rawName: "v-tippy",
                        value: { content: _vm.$t("message.copy") },
                        expression: "{ content: $t('message.copy') }",
                      },
                    ],
                    staticClass: "copy-btn",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.copyPayload.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v(_vm._s(_vm.copied ? "check" : "content_copy")),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("pre", { staticClass: "json-content" }, [
                _vm._v(_vm._s(_vm.prettyPayload)),
              ]),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }